import { Pipe, PipeTransform } from '@angular/core';
import { Option } from '@dch/products-business-logic';

@Pipe({
  name: 'excludeFavAppOption',
})
export class ExcludeFavAppOptionsPipe implements PipeTransform {
  transform(values: Array<Option>): any {
    return (values || []).filter((v) => v.optionGroup !== 'FAVAPP');
  }
}
